import type { ReactNode } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { Dropdown, DropdownItem, DropdownTitle } from '@/components/Dropdown'
import { SectionHeaderAction } from '@/components/Section'
import { type EventFilter } from '@/features/jobs/details/DetailsViewModel'

export interface EventsCardProps {
  filters: ReactNode
  children?: ReactNode
}

export function EventsCard({ filters, children }: EventsCardProps) {
  return (
    <Card testId="events-new">
      <CardHeader>
        <CardTitle>All events {filters}</CardTitle>
      </CardHeader>
      {children}
    </Card>
  )
}

export interface EventsCardListProps {
  children?: ReactNode
}

export function EventsCardList({ children }: EventsCardListProps) {
  return (
    <CardContent scroll listContent>
      {children}
    </CardContent>
  )
}

export interface EventsFiltersProps {
  eventFilter: EventFilter
  onEventFilterChange: (filter: EventFilter) => unknown
  icon: ReactNode
}

export function EventsFilters({
  eventFilter,
  onEventFilterChange,
  icon,
}: EventsFiltersProps) {
  return (
    <Dropdown
      autoDismiss
      position="bottom"
      testId="job-events-filters-new"
      minWidth={200}
      button={
        <SectionHeaderAction compact title={getEventFilterText(eventFilter)}>
          {icon}
        </SectionHeaderAction>
      }
    >
      <DropdownTitle>Event type</DropdownTitle>
      <DropdownItem
        active={eventFilter === 'All'}
        checkmark={eventFilter === 'All'}
        onPress={() => onEventFilterChange('All')}
        testId="job-events-filter-all-new"
      >
        {getEventFilterText('All')}
      </DropdownItem>

      <DropdownItem
        active={eventFilter === 'JobUpdates'}
        checkmark={eventFilter === 'JobUpdates'}
        onPress={() => onEventFilterChange('JobUpdates')}
        testId="job-events-filter-job-updates-new"
      >
        {getEventFilterText('JobUpdates')}
      </DropdownItem>

      <DropdownItem
        active={eventFilter === 'TaskUpdates'}
        checkmark={eventFilter === 'TaskUpdates'}
        onPress={() => onEventFilterChange('TaskUpdates')}
        testId="job-events-filter-task-updates-new"
      >
        {getEventFilterText('TaskUpdates')}
      </DropdownItem>
    </Dropdown>
  )
}

function getEventFilterText(filter: EventFilter) {
  switch (filter) {
    case 'All':
      return 'All updates'
    case 'JobUpdates':
      return 'Job updates'
    case 'TaskUpdates':
      return 'Task updates'
  }
}
